import React, { useState } from 'react';
import Header from "./header";
import Footer2 from "./Footer2";
const mainContentContainerStyle = {
    maxWidth: '1400px',
    width: '90%',
    margin: '0 auto',
    paddingLeft: '16px', // Reduced section padding in favor of container width
    paddingRight: '16px',
};
const cardHoverProps = {
    onMouseEnter: (e) => {
        e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
        e.currentTarget.style.boxShadow = '0 10px 20px rgba(37, 99, 235, 0.15)'; // Adjusted shadow for less lift
        e.currentTarget.style.borderColor = 'rgba(37, 99, 235, 0.2)';
    },
    onMouseLeave: (e) => {
        e.currentTarget.style.transform = 'translateY(0) scale(1)';
        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
        e.currentTarget.style.borderColor = 'rgba(0,0,0,0.06)';
    }
};

const jobCardHoverProps = {
    onMouseEnter: (e) => {
        e.currentTarget.style.transform = 'translateY(-8px)';
        e.currentTarget.style.boxShadow = '0 15px 30px rgba(37, 99, 235, 0.2)'; // Adjusted shadow for less lift
    },
    onMouseLeave: (e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.1)';
    }
};


export default function CareersPage() {
    const [toast, setToast] = useState({ visible: false, message: '' });

    const showToast = (message) => {
        setToast({ visible: true, message });
        setTimeout(() => setToast({ visible: false, message: '' }), 3000);
    };

    const handleApply = (jobTitle) => {
        showToast(`Application started for ${jobTitle}!`);
    }

    // --- Job Data ---
    const jobListings = [
        { title: 'Senior Software Engineer', location: 'San Francisco, CA', type: 'Full-time', desc: 'Join our engineering team to build scalable solutions and work with cutting-edge technologies.' },
        { title: 'Product Designer', location: 'Remote', type: 'Full-time', desc: 'Create beautiful and intuitive user experiences that delight our customers every day.' },
        { title: 'Marketing Manager', location: 'New York, NY', type: 'Full-time', desc: 'Lead our marketing initiatives and help us reach new audiences with creative campaigns.' },
        { title: 'Customer Success Lead', location: 'Austin, TX', type: 'Full-time', desc: 'Build strong relationships with our customers and ensure they achieve their goals with our platform.' }
    ];

    // --- Benefits Data ---
    const benefits = [
        { icon: '💰', title: 'Competitive Salary Structure', desc: 'Fair and attractive compensation packages aligned with industry standards' },
        { icon: '📚', title: 'Learning & Development', desc: 'Skill development opportunities and training programs to enhance your capabilities' },
        { icon: '🤝', title: 'Friendly Work Environment', desc: 'Professional yet friendly atmosphere that encourages collaboration' },
        { icon: '📈', title: 'Career Growth', desc: 'Leadership exposure and clear paths for career advancement' },
        { icon: '🎉', title: 'Employee Engagement', desc: 'Team activities and events that build strong workplace relationships' },
        { icon: '🛡️', title: 'Job Stability', desc: 'Transparent policies and secure employment with a trusted organization' }
    ];


    return (
        <>
            <Header />
            <div style={{ backgroundColor: "#f8f9fa", color: "#1a1a1a", fontFamily: "system-ui, -apple-system, sans-serif", minHeight: '100vh' }}>

                {/* Header Section */}
                <header style={{ background: 'linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(37, 99, 235, 0.02) 100%)', paddingTop: '80px', paddingBottom: '80px', paddingLeft: '32px', paddingRight: '32px' }}>
                    <div style={{ ...mainContentContainerStyle, textAlign: 'center' }}>
                        <h1 style={{ fontSize: 'clamp(32px, 8vw, 48px)', fontWeight: 'bold', marginBottom: '24px', lineHeight: '1.2' }}>🚀 Build Your Future With Us</h1>
                        <p style={{ fontSize: 'clamp(16px, 4vw, 20px)', lineHeight: '1.6', maxWidth: '48rem', margin: '0 auto', opacity: 0.9 }}>We are always looking for talented, motivated, and curious individuals who want to make an impact. Whether you are a fresher or an experienced professional, Indycium offers a platform to learn, grow, and succeed.</p>
                    </div>
                </header>

                <hr style={{ border: 'none', margin: 0 }} />

                {/* Who We're Looking For Section */}
                <section style={{ paddingTop: '64px', paddingBottom: '64px' }}>
                    <div style={mainContentContainerStyle}>
                        <h2 style={{ fontSize: 'clamp(28px, 6vw, 36px)', fontWeight: 'bold', marginBottom: '48px', textAlign: 'center' }}>👥 Who We're Looking For</h2>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '24px' }}>
                            {['Self-motivated and proactive individuals', 'Strong communication and teamwork skills', 'Problem-solvers and critical thinkers', 'Adaptable and eager to learn', 'Professionals with integrity and accountability', 'Curious and results-driven attitude'].map((item, idx) => (
                                <div key={idx} style={{ display: 'flex', gap: '16px', padding: '12px 20px', borderRadius: '12px', backgroundColor: '#ffffff', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #f3f4f6' }}>
                                    <div style={{ fontSize: '24px', marginTop: '4px', flexShrink: 0, color: '#2563eb' }}>✓</div>
                                    <p style={{ fontSize: '18px' }}>{item}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <hr style={{ border: 'none', margin: 0 }} />

                {/* What We Offer Section */}
                <section style={{ background: 'linear-gradient(135deg, rgba(37, 99, 235, 0.03) 0%, rgba(37, 99, 235, 0.01) 100%)', paddingTop: '40px', paddingBottom: '40px' }}>
                    <div style={mainContentContainerStyle}>
                        <h2 style={{ fontSize: 'clamp(28px, 6vw, 36px)', fontWeight: 'bold', marginBottom: '48px', textAlign: 'center' }}>💼 What We Offer</h2>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '32px' }}>
                            {benefits.map((benefit, idx) => (
                                <div
                                    key={idx}
                                    style={{ padding: '12px 22px', borderRadius: '12px', textAlign: 'center', backgroundColor: '#ffffff', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid rgba(0,0,0,0.06)', transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)', cursor: 'pointer' }}
                                    {...cardHoverProps}
                                >
                                    <div style={{ fontSize: '48px', marginBottom: '16px' }}>{benefit.icon}</div>
                                    <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '12px' }}>{benefit.title}</h3>
                                    <p style={{ fontSize: '16px', lineHeight: '1.6' }}>{benefit.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <hr style={{ border: 'none', margin: 0 }} />

                {/* Job Listings Section */}
                <main style={{ paddingTop: '40px', paddingBottom: '40px' }}>
                    <div style={mainContentContainerStyle}>
                        <h2 style={{ fontSize: 'clamp(28px, 6vw, 36px)', fontWeight: 'bold', marginBottom: '48px', textAlign: 'center' }}>📍 Current Openings</h2>
                        <div style={{ display: 'grid', gap: '32px' }}>
                            {jobListings.map((job, idx) => (
                                <div
                                    key={idx}
                                    style={{ borderRadius: '12px', padding: '12px 22px', boxShadow: '0 10px 25px rgba(0,0,0,0.1)', borderLeft: '4px solid #2563eb', backgroundColor: '#ffffff', transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)', cursor: 'pointer' }}
                                    {...jobCardHoverProps}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
                                        <div style={{ flex: 1, width: '100%' }}>
                                            <h2 style={{ fontSize: 'clamp(24px, 5vw, 30px)', fontWeight: 'bold', marginBottom: '12px' }}>{job.title}</h2>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', fontSize: '16px', marginBottom: '20px' }}>
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '500' }}>📍 {job.location}</span>
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '500' }}>💼 {job.type}</span>
                                            </div>
                                            <p style={{ fontSize: '16px', lineHeight: '1.6', opacity: 0.8, marginBottom: '20px' }}>{job.desc}</p>
                                        </div>
                                        <button
                                            onClick={(e) => { e.stopPropagation(); handleApply(job.title); }} // Added e.stopPropagation() to prevent card hover state issues
                                            style={{
                                                padding: '12px 32px',
                                                borderRadius: '12px',
                                                fontWeight: 'bold',
                                                fontSize: '16px',
                                                boxShadow: '0 4px 12px rgba(37, 99, 235, 0.2)',
                                                border: 'none',
                                                whiteSpace: 'nowrap',
                                                backgroundColor: '#2563eb',
                                                color: '#ffffff',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s',
                                                alignSelf: 'flex-end' // Aligns button to the right/bottom
                                            }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 6px 16px rgba(37, 99, 235, 0.3)'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.2)'; }}
                                        >
                                            Apply Now
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </main>

                {/* Toast Notification */}
                <div style={{
                    position: 'fixed',
                    bottom: '32px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    padding: '12px 24px',
                    borderRadius: '8px',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                    transition: 'opacity 0.3s, transform 0.3s',
                    opacity: toast.visible ? 1 : 0,
                    pointerEvents: toast.visible ? 'auto' : 'none',
                    backgroundColor: '#2563eb',
                    color: '#ffffff'
                }}>
                    {toast.message}
                </div>
            </div>
            {/* FOOTER */}
            <Footer2 />
        </>
    );
}